import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  InternalApiCustomList,
  InternalApiCustomListSchemaField,
  InternalApiCustomListSignificantFields,
  InternalApiEntityType,
} from '../api-internal';

type SignificantFor = { [key in InternalApiEntityType]: boolean };

export type CustomListType = InternalApiCustomList & {
  schemaFields?: (InternalApiCustomListSchemaField & {
    significantFor?: SignificantFor;
  })[];
};

export interface CustomListsState {
  customLists: CustomListType[] | null;
}

const initialState: CustomListsState = {
  customLists: null,
};

const customListSlice = createSlice({
  name: 'custom-lists',
  initialState,
  reducers: {
    fetchCustomListsSuccess: (state, action: PayloadAction<Array<InternalApiCustomList>>) => {
      return {
        ...state,
        customLists: action.payload,
      };
    },
    fetchSchemaFieldsSuccess: (
      state,
      action: PayloadAction<{ customListId: string; schemaFields: Array<InternalApiCustomListSchemaField> }[]>
    ) => {
      action.payload.forEach((schema) => {
        const customList = state.customLists?.find((customList) => customList.id === schema.customListId);
        if (customList) {
          customList.schemaFields = schema.schemaFields;
        }
      });
    },
    fetchSignificantFieldsSuccess: (
      state,
      action: PayloadAction<{ customListSignificantFields: InternalApiCustomListSignificantFields }>
    ) => {
      const { customListSignificantFields } = action.payload;
      state.customLists?.forEach((customList) => {
        const customListConfig = customListSignificantFields._configuration.find(
          (customListConfig) => customListConfig.listId === customList.id
        );
        customList.schemaFields?.forEach((schemaField) => {
          if (!schemaField.significantFor) {
            schemaField.significantFor = {} as SignificantFor;
          }
          schemaField.significantFor[customListSignificantFields.entityType] = !!customListConfig?.fields.includes(
            schemaField.id!
          );
        });
      });
    },

    fetchCustomListSuccess: (state, action: PayloadAction<InternalApiCustomList>) => {
      return {
        ...state,
        customLists: [...(state.customLists ?? []), action.payload],
      };
    },
  },
});

const { actions, reducer } = customListSlice;
export const {
  fetchCustomListsSuccess,
  fetchSchemaFieldsSuccess,
  fetchSignificantFieldsSuccess,
  fetchCustomListSuccess,
} = actions;
export default reducer;
